//import { TransactionPin } from "@/components";
import { TransactionPin } from "@/components";
import { MODAL_HEADERS } from "@/data";
import { PayXpressState } from "@/models";
import { useApiStore, useAppStore, useComponentStore } from "@/store";
import { useCallback, useEffect } from "react";

export const useHomePage = () => {
  const componentState = useComponentStore((state) => state);
  const apiState = useApiStore((state) => state);
  const appState = useAppStore<any>((state) => state);
  const { modal, setAllState } = componentState;
  const { walletDetails } = useAppStore<PayXpressState.BillPaymentPage>(
    (state) => state
  );

  const clearHomePageState = useCallback(() => {
    setAllState({ ...componentState, componentSteps: 0 });
    apiState.setAllState({
      ...apiState,
      payload: undefined,
      submitForm: false,
      form: undefined,
    });
    appState.setAllState(undefined);
  }, [apiState.setAllState, appState.setAllState, setAllState]);

  const setTransactionPin = useCallback(() => {
    if (walletDetails && !walletDetails?.isPinSet) {
      modal.set(
        410,
        <TransactionPin />,
        false,
        <div className="flex gap-3 items-center">
          <span className="font-semibold">
            {MODAL_HEADERS.CREATE_TRANSACTION_PIN}
          </span>
        </div>
      );
    }
  }, [walletDetails]);

  useEffect(() => {
    setTransactionPin();
  }, [setTransactionPin]);

  return { clearHomePageState };
};
